import { useStore } from '../../store/useStore';
import { Task } from '../../types/task';
import { isExecutive } from '../../utils/auth';
import { UserRole } from '../../types';

export const useTaskPermissions = () => {
  const { currentUser } = useStore();

  const canManageTask = (task: Task) => {
    if (!currentUser) return false;
    
    // Task creator can manage their created tasks
    if (task.assignedBy === currentUser.id) return true;
    
    // Department managers can manage department tasks
    if (currentUser.role === 'MANAGER' && task.department === currentUser.department) return true;

    return false;
  };

  const canUpdateStatus = (task: Task) => {
    if (!currentUser) return false;
    return task.assignedTo === currentUser.id || canManageTask(task);
  };

  const canAssignSubtasks = (task: Task) => {
    if (!currentUser) return false;
    return isExecutive(currentUser.role) || task.assignedTo === currentUser.id || canManageTask(task);
  };

  const canDelegate = (task: Task) => {
    if (!currentUser) return false;
    return isExecutive(currentUser.role) || task.assignedTo === currentUser.id || canManageTask(task);
  };
  const canAssignToExecutive = (userRole: UserRole) => {
    // Allow managers and employees to assign tasks to executives
    return ['MANAGER', 'EMPLOYEE'].includes(userRole);
  };

  return {
    canManageTask,
    canUpdateStatus,
    canAssignSubtasks,
    canDelegate,
    canAssignToExecutive
  };
};